import { create } from "zustand";
import axios from "axios";

const statusStore = create((set, get) => ({
    status: [],

    statusForm: {
        seriesId: "",
        userStatus: "",
        rating: "",
        note: "",
        tags: [],
    },

    fetchStatus: async () => {
        // Fetch the status
        const res = await axios.get("/status");

        // Set to state
        set({ status: res.data.statuses || [] });
    },

    //NEW
    fetchEpisodeStatuses: async (seriesId) => {
        const state = get();
        try {
            const res = await axios.get(`/status/episodes/${seriesId}`, {
                method: "GET",
                credentials: "include" // needed if using cookie auth
            });

            const data = await res.json();

            // Update in local state
            set({ status: res.data.statuses || [] });
            return data.statuses;

        } catch (err) {
            console.error(err);
        }
    },

    /* NOT DONE */
    /* app.post("/status", requireAuth, statusController.createStatus);
       app.put("/status/:id", requireAuth, statusController.updateStatus);const { seriesId,
                season,
                episode,
                targetId,
                targetType,
                userStatus,
                rating,
                review,
                tags } = req.body;*/
    createEpisodeStatus: async(seriesId, season, episode, targetId, targetType, userStatus) => {
        try {
            let res = await axios.post(`/status`, { seriesId, season, episode, targetId, targetType, userStatus });

            console.log("Adding this to the statuses:", res.data);
            // Add new one to local state
            set((state) => ({
                status: [...state.status, res.data.status]
            }));
            
        } catch (err) {
            console.log("Error");
            return err;
        }
    },

    updateEpisodeStatus: async(episodeId) => {
        const state = get();

        // Check if there is an existing status for this series
        const existingStatus = state.status.find((s) => s.targetId === episodeId);
            
        if (!existingStatus) {
            console.log("Update episode status - no existing status");
            return "No existing status";
        }

        console.log("Existing status is ", existingStatus);
        let userStatus = "Watched";
        if (existingStatus.userStatus === "Watched") {
            userStatus = "Not Interested";
            console.log("User status was updated to ", userStatus);
        }

        try {
            let res = await axios.put(`/status/${existingStatus._id}`, { userStatus });

            // Update in local state
            set({
                status: state.status.map((s) =>
                    s._id === existingStatus._id ? { ...s, userStatus } : s
                ),
            });
        } catch (err) {
            console.log("Error");
            return err;
        }
    },

    createSeriesStatus: async(seriesId, season, episode, targetId, targetType, userStatus, rating, review, tags) => {
        const state = get();
        try {
            let res = await axios.post(`/status`, { seriesId, season, episode, targetId, targetType, userStatus, rating, review, tags });
            // Add new one to local state
            //set({ status: [...state.status, res.data] });
        } catch (err) {
            console.log("Error");
            return err;
        }
    },

    updateStatus: async (seriesId, userStatus, airingStatus) => {
        const state = get();

        // Find existing status for this series
        const existingStatus = state.status.find((s) => s.seriesId === seriesId);

        // Fix user status language if on the getstarted page
        if (airingStatus === "Continuing" && userStatus === "Finished") {
            userStatus = "Finished what's available";
        }
        
        if (existingStatus !== "Not Interested") {
            try {
                let res;

                if (existingStatus) {
                    // Update existing status 
                    res = await axios.put(`/status/${existingStatus._id}`, { seriesId, userStatus });

                    // Update in local state
                    set({
                        statuses: state.status.map((s) =>
                            s._id === existingStatus._id ? { ...s, userStatus } : s
                        ),
                    });
                    console.log("Status updated:", res.data);
                } else {
                    // Create new status
                    res = await axios.post(`/status`, { seriesId, userStatus });

                    // Add new one to local state
                    set({ statuses: [...state.status, res.data] });
                    console.log("New status created:", res.data);
                }
            } catch (err) {
                console.error("Error saving status:", err);
            }
        } else if (existingStatus === "Not interested") {
            // Delete the status 
            try {
                let res;
                res = await axios.delete(`/status/${existingStatus._id}`);
            } catch (err) {
                console.error("Error deleting status:", err);
            }    
        }
    },

    // updateNote: async (seriesId, note) => {
        
    // },
}));

export default statusStore;